import { render, staticRenderFns } from "./User__Albums.vue?vue&type=template&id=02da71ac&lang=pug&"
import script from "./User__Albums.vue?vue&type=script&lang=js&"
export * from "./User__Albums.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports